import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative pt-10 pb-8 sm:pt-14 sm:pb-10" data-testid="site-footer">
      <div className="mt-container">
        <div className="mt-glass mt-rainbow-edge rounded-2xl sm:rounded-3xl px-5 py-8 sm:px-8 sm:py-10 lg:px-12 lg:py-14">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10 lg:items-start lg:justify-between mb-8">
            <div className="max-w-xs">
              <div className="flex items-center gap-3 mb-4">
                <img src="/logo.png" alt="MT" style={{width:36,height:36,objectFit:"contain",opacity:0.85,filter:"invert(var(--mt-logo-invert)) drop-shadow(0 0 8px rgba(0,170,255,0.2))"}}/>
                <p className="font-mono text-[0.62rem] tracking-mt uppercase" style={{color:"var(--mt-text-muted)"}}>Million Threads · Drop 01</p>
              </div>
              <h3 className="font-display font-light leading-[1.1] text-[clamp(1.6rem,4vw,3rem)]">
                <span className="mt-chrome-text mt-keep-anim">A million stories.</span><br/>One thread.
              </h3>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 lg:gap-14">
              <ColLinks title="Navigate" items={[
                {to:"/",label:"Home"},{to:"/shop",label:"Shop"},{to:"/about",label:"About"},{to:"/contact",label:"Contact"},
              ]}/>
              <ColLinks title="Account" items={[
                {to:"/profile",label:"Profile"},{to:"/contact",label:"Support"},
              ]}/>
              <ColLinks title="Legal" items={[
                {to:"/terms",label:"Terms & Conditions"},{to:"/privacy",label:"Privacy Policy"},{to:"/refund",label:"Refund & Returns"},{to:"/shipping",label:"Shipping Policy"},
              ]}/>
              <div className="col-span-2 sm:col-span-1">
                <p className="font-mono text-[0.62rem] tracking-mt uppercase mb-3 opacity-60">Reach</p>
                <a href="mailto:support.millionthreads@gmail.com" className="font-body text-[0.78rem] sm:text-sm whitespace-nowrap hover:opacity-80 transition-opacity" style={{ color: "var(--mt-text)" }}>support.millionthreads@gmail.com</a>
                <p className="font-mono text-[0.58rem] tracking-mt uppercase mt-2 opacity-50 leading-relaxed whitespace-nowrap">We respond within 24 hours.</p>
              </div>
            </div>
          </div>
          <div style={{height:1,background:"var(--mt-glass-border)",marginBottom:"1.25rem"}}/>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="font-mono text-[0.58rem] tracking-mt uppercase opacity-40">© {new Date().getFullYear()} Million Threads. Built different.</p>
            <p className="font-mono text-[0.58rem] tracking-mt uppercase opacity-40">Worn by few. Known by those who matter.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

function ColLinks({ title, items }) {
  return (
    <div>
      <p className="font-mono text-[0.62rem] tracking-mt uppercase mb-3 opacity-60">{title}</p>
      <ul className="space-y-2.5">
        {items.map((it)=>(
          <li key={it.to}><Link to={it.to} className="mt-nav-link text-sm">{it.label}</Link></li>
        ))}
      </ul>
    </div>
  );
}
